<template>
  <cs-preloader-overlay :loading="loading">
    <div v-if="widget" class="widget-container">
      <div class="widget-form-container">
        <div class="section-container">
          <substrate-mount>
            <div class="textarea-composite-container">
              <input-textarea
                ref="description"
                v-model="widget.description"
                :required="false"
                :max-length="255"
                :rows="1"
                input-id="widget-description"
                :input-name="$t('common.target')"
                :input-placeholder="$t('collect.for.what')"
                composite
              />
              <!-- TODO: @danealton доработать новый компонент загрузки файлов -->
              <!-- <div class="uploading-area-composite-container">
                <uploading-image
                  :size="{
                    width: '60px',
                    height: '60px',
                  }"
                  :attachment-link="widget.attachment.link"
                  input-id="widget.attachment"
                  border-radius="5px"
                />
              </div> -->
              <attachment-image
                :link="widget.attachment.link"
                input-id="widget.attachment"
                type="secondary"
                composite
                composite-textarea
                @loading="onImageLoading"
                @uploaded="data => widget.attachment.setData(data)"
                @reset="widget.attachment.reset()"
              />
            </div>
            <div class="input-container">
              <input-price
                ref="amountGoal"
                v-model.lazy="widget.amountGoal"
                input-id="amount-goal"
                :input-name="`${$t('need.to.collect')}, ${currency.sign}`"
                :input-title="$t('enter.amount')"
                :min-value="1"
                :currency="currency"
                @change="widget.amountGoal = $event"
              />
            </div>
            <div class="input-container">
              <input-price
                ref="startFrom"
                v-model.lazy="widget.startFrom"
                input-id="start-from"
                :input-name="`${$t('start.from')}, ${currency.sign}`"
                :input-title="$t('enter.amount')"
                :min-value="0"
                :currency="currency"
                @change="widget.startFrom = $event"
              />
            </div>
          </substrate-mount>
        </div>

        <div class="button-primary-container">
          <cs-button :width="buttonWidth" :disabled="!isValid" @click="handleSubmit">
            {{ $t('common.proceed') }}
          </cs-button>
        </div>
      </div>
    </div>
  </cs-preloader-overlay>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import attachmentMixin from 'lib/mixins/attachmentMixin';
import AttachmentImage from 'modules/AttachmentImage';

import { fetchByCode } from 'services/widget';
import GoalWidget from 'services/widget/GoalWidget';

import SubstrateMount from '@/components/capusta/SubstrateMount';
import InputTextarea from '@/components/inputElements/InputTextarea';
import InputPrice from '@/components/inputElements/InputPrice';

// import UploadingImage from 'molecules/uploading-image';

export default {
  name: 'GoalForm',
  mixins: [
    attachmentMixin,
  ],
  components: {
    AttachmentImage,
    SubstrateMount,
    InputTextarea,
    InputPrice,
    // UploadingImage,
  },
  created() {
    this.initialize();
  },
  data() {
    return {
      loading: false,
      widget: null,
    };
  },
  computed: {
    currency() {
      return this.PROJECT_INFO.currency;
    },
    widgetCode() {
      return this.$route.query?.code || null;
    },
    formattedAmountGoal() {
      return this.widget.normalizeAmountGoal();
    },
    formattedStartFrom() {
      return this.widget.normalizeStartFrom();
    },
    isValid() {
      if (this.submittingDisabled || this.loading) {
        return false;
      }

      if (this.formattedAmountGoal < 1) {
        return false;
      }

      return true;
    },
    buttonWidth() {
      return this.isDesktop ? 223 : '100%';
    },
    ...mapState(['PROJECT_INFO']),
    ...mapGetters(['isDesktop']),
  },
  methods: {
    async initialize() {
      this.loading = true;

      try {
        const data = await fetchByCode(this.widgetCode);

        this.widget = new GoalWidget({
          ...data,
          currency: this.currency,
        });
      } catch (error) {
        this.widget = new GoalWidget({
          currency: this.currency,
        });
      }

      this.loading = false;
    },
    handleSubmit() {
      this.$emit('submit', this.widget.getData());
    },
  },
};
</script>

<style lang="sass" scoped>
  @import '~styles/components/widgets/widget-form'

  .widget-container
    display: flex
    justify-content: center

  .textarea-composite-container
    position: relative
    display: flex
    align-items: center

    .textarea
      margin: 0

  // .uploading-area-composite-container
  //   position: absolute
  //   top: 10px
  //   right: 10px
  //   z-index: 1000
</style>
